import type { ToolCallEntry } from "@/lib/planner/chatTurns";

/** The Gondola MCP App views the concierge may render (GON-7817). */
export const MCP_APP_URIS = [
  "ui://gondola/hotel-search/v1",
  "ui://gondola/hotel-details/v1",
  "ui://gondola/compare-rates/v1",
  "ui://gondola/booking-receipt/v1",
] as const;

export type McpAppUri = (typeof MCP_APP_URIS)[number];

export interface McpAppPayload {
  resourceUri: McpAppUri;
  toolName: string;
  structuredContent: Record<string, unknown>;
}

export function isPlainObject(
  value: unknown
): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/** The validated `mcp_app` payload the backend attached to a tool result, if any. */
export function mcpAppPayload(
  call: Pick<ToolCallEntry, "widgetData">
): McpAppPayload | null {
  const app = call.widgetData?.mcp_app;
  if (!isPlainObject(app)) return null;
  const { resource_uri, tool_name, structured_content } = app;
  if (!MCP_APP_URIS.includes(resource_uri as McpAppUri)) return null;
  if (typeof tool_name !== "string" || !isPlainObject(structured_content))
    return null;
  return {
    resourceUri: resource_uri as McpAppUri,
    toolName: tool_name,
    structuredContent: structured_content,
  };
}
